import { homeownerQuotesService } from '@/services/quotes/homeowner';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useInspectionDocument(policyId: string | undefined) {
  return useQuery({
    queryKey: ['inspection-document', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('PolicyId é obrigatório');
      }

      const response = await homeownerQuotesService.getInspectionDocument(policyId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar documento de inspeção'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
    enabled: !!policyId,
  });
}
